export default "__VITE_ASSET__6X7N6zlM__"